import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DoubleColumn from './icon-double-column.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DoubleColumn {...validProps} />;
}
SvgComponent.iconName = 'double-column';

export const DoubleColumnIcon = svgIconWrapper(SvgComponent);
